<template>
  <van-row>
    <van-sticky>
      <van-nav-bar
          title="111114111"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
      />
    </van-sticky>
    <div class="com-detail" v-if="show">
      <div class="com-top">
        <div class="com-avatar">
          <img :src="companyData.logo">
        </div>
        <div class="com-top-right">
          <div class="name">{{companyData.companyname}}</div>
          <div class="more-info">
            <span class="lab">{{companyData.nature_cn}}</span>|<span class="lab"> {{companyData.scale_cn}}</span>|<span class="lab"> {{companyData.district_cn}}</span>
          </div>
        </div>
      </div>
      <div class="split-block"></div>
      <div class="c-des">
        <div class="c-title">公司介绍</div>
        <div class="c-des-txt" :class="{txtMore:isShow}" ref="desBox">{{companyData.contents}}</div>
        <div class="show-more" @click="showMore" v-if="isBtnShow">
          <div class="show-btn " v-if="isShow">收起信息</div>
          <div class="show-btn " v-else>展开信息</div>
        </div>
      </div>
      <div class="split-block"></div>
      <div class="c-contact">
        <div class="c-title">联系方式</div>
        <div class="r-tr">
          <div class="l-tit">联系人：</div>
          <div class="r-txt">{{companyData.contact}}</div>
        </div>
        <div class="r-tr" v-if="!isEmptyVal(companyData.mobile)">
          <div class="l-tit">手机：</div>
          <div class="r-txt" v-html="companyData.mobile"></div>
        </div>
        <div class="r-tr" v-if="!isEmptyVal(companyData.landline_tel)">
          <div class="l-tit">电话：</div>
          <div class="r-txt" v-html="companyData.landline_tel"></div>
        </div>
        <div class="r-tr" v-if="!isEmptyVal(companyData.email)">
          <div class="l-tit">邮箱：</div>
          <div class="r-txt" v-html="companyData.email"></div>
        </div>
        <div class="r-tr" v-if="!isEmptyVal(companyData.address)">
          <div class="l-tit">地址：</div>
          <div class="r-txt" v-html="companyData.address"></div>
        </div>
      </div>
    </div>
  </van-row>
</template>

<script>
import {mapState} from 'vuex'
import {isEmpty} from '@/utils/common'

export default {
  name: 'CompanyView',
  data() {
    return {
      show:false,
      isShow:true,
      isBtnShow:false
    }
  },
  computed:{
    ...mapState('common', ['companyData']),
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration:0,
    })
  },
  mounted() {
    this.$store.dispatch('common/companyDetail',this.$route.query.companyId).then(()=>{
      this.show=true
      this.$toast.clear()
    })
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },
    isEmptyVal(param) {
      return isEmpty(param)
    },
    showMore() {
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="stylus" scoped>
.p-namecard {
  .m-list {
    padding-top: 2.6rem;
  }
  .u-bottom {
    margin-bottom: 2rem;
  }
}
.g-window .m-article{
  padding-top: 2.6rem;
}
/*企业详情*/
.com-detail{
  background-color: #fff;
  font-size: .36rem;
}
.com-detail .com-top{
  display: flex;
  align-items: center;
  padding:.3rem .35rem;
}
.com-detail .com-top .com-avatar{
  margin-right: 10px;
}
.com-detail .com-top .com-avatar img{
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 5px;
  border: 1px solid #f3f3f3;
}
.com-detail .com-top .name{
  color: #333333;
  font-size: .4rem;
}
.com-detail .com-top  .more-info{
  color: #7a797a;
  font-size: .3rem;
}
.com-detail .com-top  .more-info span{
  padding: 0.1rem;
  margin-right: .2rem;
}
.com-detail .com-top  .more-info span:last-child{
  margin-right: 0;
}
.com-detail .split-block{
  height: .5rem;
  background-color: #f3f5fa;
}
.com-detail .c-title{
  padding: 0 .35rem 0 1rem;
  height: 1rem;
  line-height: 1rem;
  color: #333333;
  border-bottom: 1px #F2F2F2 solid;
  background-repeat: no-repeat;
  background-size: .5rem;
  background-position: .3rem center;
}
.com-detail .c-des .c-title{
  background-image: url("data:image/png;base64,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");
}
.com-detail .c-contact .c-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcCAYAAACdz7SqAAACx0lEQVRIibWXW4iNURSAvz0ow4MXySWDRh6UIklGRhlkxGhG8jAkDzTxYEpStBj/JjUUXkzEAyK535Xbg8ygccn1hRiSotwK8TAt7f/fpzlzzj/nzJxz7PovZ6+11/fvvddeax2jqnRq1lQBx4EvQDWiDyhwK0oBNgDngZ/AYKAVaxb/P6g1O4DNwF5EByHaB7gVztqapQWluuXVgEYNUA3YFv5OvgKueNnCNFmOl9GACcAjoAnRVbFfZs1VYA5QhejFfCfqoNeACkR7ZdS0phkoA0oRfZMP1O3peOBlVk3Rqf5tYz7ABPQr0D+rpjVj/duzQkCfAKOyAEuBF8BzRHcXAnrbGy7pAjgaeA18ACblC0xAT/r3lTFAt+yvgKfAcET/FAYq+tkvcZyDtPtnG6Ix4lyhUasL79bUdpJGM1sfnk9rygoF7Qj41rhlHIZovzQta94Bbs97I9qebqZnLTngzwaKsWZXjIVp/vk4/3kmQ0XfAgeA+jRPFn0PzALGYc3NfKFx+fQ78BvRoWna1tQAp/0xmx7rXNbMB7b79LgG0fupKkXpo5gMDMGaI2kS0TPAAqAc+IQ1I1KAm4ALfv+dnXtYU5l9ptHgujDrgCC6NUbugkRL6FiwGjgEbAHWAocRXeb13FbMABYheiozNDK8zweMWkSPxciLAWdoblLvHkTrU/QS4BpEz4Z9GRNxwFGfwJdn0KnQgGYNkAw6N7ydyiiJdzXTji89ES6PCxKijZmVM9q5Dsx0DpgdGg3Y6ffrHKLVeYAdrKV70GjACmA/8AOoRPRuD4FTvPM1dR8aDZwIXPLl6UFgHaLfujHOVR13fGIp7xm0w0hiuV1rCI+MaFsXuq7icAWAy2YliP7NDRoZG+nuwBLf4yrKy8BDn38HAvMAFzA+AmMQ/eUUc4d2hm8AXEHe1/c6yABfe7V6H3B/UwD4Bz7TfWJxoqzjAAAAAElFTkSuQmCC");
}
.com-detail .c-des .c-des-txt{
  padding: .3rem .35rem;
  color: #999999;
  word-break: break-all;
  max-height: 6rem;
  overflow: hidden;
}
.com-detail .c-des .c-des-txt.txtMore{
  height: auto;
  max-height: none;
}
.com-detail .c-des .show-more{
  text-align: center;
  height: 1rem;
  line-height: 1rem;
  color: #999;
  font-size: .28rem;
}
.com-detail .r-tr{
  display: flex;
  align-items: center;
  padding: 0.3rem .35rem;
}
.com-detail .r-tr .l-tit{
  flex-shrink: 0;
  color: #6d6c6c;
  width: 2rem;
}
.com-detail .c-contact{
  padding-bottom: .3rem;
}
</style>
